module.exports = __webpack_public_path__ + "img/1.822d95e9.jpg";